// extracted by mini-css-extract-plugin
export default {"Box":"access-settings-view-module__Box--khdE9","Heading":"access-settings-view-module__Heading--MUNgn"};